

import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'

import Cookies from 'js-cookie'
import { getTokenSyn } from '@/utils/auth'
import { getQueryNew } from '@/utils/index'
import {
updateLinkID,
pageView
} from '@/api/other'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import 'lib-flexible' 
import VConsole from 'vconsole' 
let vConsole = new VConsole() 

Vue.use(ToastPlugin, { position: 'top' })
Vue.use(LoadingPlugin)
Vue.use(WechatPlugin)
Vue.use(ConfirmPlugin)
Vue.use(router)
Vue.use(AjaxPlugin)

FastClick.attach(document.body)

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {



Vue.$vux.loading.show()














function init () {


if (to.meta.requireLogin && localStorage.getItem('accountIsLogin') !== 'true') {

next('/login')
return
}



const tokenStr = window.localStorage.getItem('token')
const tokenJson = JSON.parse(tokenStr)
const timestamp = Date.parse(new Date())
const isLogin = window.localStorage.getItem('isLogin')
console.log('main-init-1：' + to.path )

if (window.location.href.indexOf('?from=') > -1 || window.location.href.indexOf('isappinstalled') > -1) {

console.log('main-init-2')
window.location.href = window.location.href.split('?')[0] + '#/' + window.location.href.split('#/')[1]
return
}


if (tokenJson && to.path !== '/author')
{
if ((tokenJson.token.length != 33)||(tokenJson.time * 1000 < timestamp))
{
window.localStorage.removeItem('token');
window.localStorage.removeItem('isLogin');
console.log('二次授权')
window.localStorage.setItem('beforeLoginUrl', JSON.stringify(to.fullPath))
Cookies.set('beforeLoginUrl', to.fullPath) 
next('/author')
return
}
}


console.log('main-init-3')
if (!tokenJson && to.path !== '/author') {

console.log('main-init-4')
window.localStorage.setItem('beforeLoginUrl', JSON.stringify(to.fullPath))
Cookies.set('beforeLoginUrl', to.fullPath) 
next('/author')
return
} else if (tokenJson && timestamp + 200000 > tokenJson.time * 1000) {
/*      // token 过期
console.log('main-init-5')
window.localStorage.removeItem('token');
window.localStorage.setItem('beforeLoginUrl', JSON.stringify(to.fullPath))
Cookies.set('beforeLoginUrl', to.fullPath) 
next('/author')
return*/

getTokenSyn()
.then(res => {
if (res.data.errorcode === 0) {

const JsonObj = {
token: res.data.data.token,
time: res.data.data.expirestime
}
console.log(`获取成功${res.data.data.token}`)
localStorage.setItem('token', JSON.stringify(JsonObj))
if (res.data.data.islogin === 1) {
localStorage.setItem('isLogin', true)
localStorage.setItem('shareid', res.data.data.shareid)
} else {
localStorage.setItem('isLogin', false)
localStorage.setItem('shareid', res.data.data.shareid)
}
next()
} else {
Vue.$vux.toast.text('获取token失败')
next('/author')
console.log('重新获取失败')
}
})
.catch(err => {
Vue.$vux.toast.text('获取token失败')
next('/author')
console.log(err)
})
return
} else if (tokenJson && to.path === '/login' && localStorage.getItem('accountIsLogin') === 'true') {
console.log('main-init-6')
next('/home')
return
} else if (to.path === '/login' || to.path === '/register') {

console.log('main-init-7')


if (from.path !== '/login' && from.path !== '/register') {
console.log('main-init-8')
localStorage.setItem('beforeLoginPath', from.path)
localStorage.setItem('beforeLoginQuery', JSON.stringify(from.query))
localStorage.setItem('beforeLoginFullpath', from.fullPath)
}
}
if (process.env.NODE_ENV === 'production' && from.path !== '/author') {


console.log('main-init-9')
var agent = navigator.userAgent.toLowerCase()
var curUri = window.location.href.indexOf('/weixin') 

if (agent.match(/MicroMessenger/i) == "micromessenger" && curUri == -1) {


console.log('main-init-10')
let uri = window.location.href.split('/wap')[0] + '/weixin' + window.location.href.split('/wap')[1]

window.location.href = window.location.href.split('/wap')[0] + '/weixin' + window.location.href.split('/wap')[1]
return
} else if (agent.match(/MicroMessenger/i) != "micromessenger" && window.location.href.indexOf('/wap/') == -1) {

console.log('main-init-11')
let uri = window.location.href.split('/weixin')[0] + '/wap' + window.location.href.split('/weixin')[1]


window.location.href = window.location.href.split('/weixin')[0] + '/wap' + window.location.href.split('/weixin')[1]
return
}
console.log('main-init-12')

if (tokenJson) {

const postData = {

page: 'http://' + window.location.host + '/weixin/index.html#' + to.fullPath
}
pageView(postData)
.then(res => {
if (res.data.errorcode === 0) {
console.log('main-init-13')

} else {
console.log('main-init-14')

}
})
.catch(err => {
console.log('main-init-15')

})
}
}
console.log('main-init-16')

if (to.path === '/address' && from.path === '/confirmOrder') {
localStorage.setItem('beforeConfirmPath', from.fullPath)
}

if (tokenJson) {


console.log('main-init-17')
Vue.http.get(process.env.BASE_API + '/?s=Api/System/getWeixinTicket', {
params: {

url: 'http://' + location.hostname + '/weixin/index.html'
}
})
.then(function (res) {
console.log('main-init-18')

const wxConfig = {
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.data.appId, // 必填，公众号的唯一标识
timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.data.signature, // 必填，签名
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'scanQRCode'] 
}

Vue.wechat.config(wxConfig)

Vue.wechat.ready(() => {
Vue.wechat.checkJsApi({
jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'scanQRCode'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
success: function (res) {

}
})

const shareid = localStorage.getItem('shareid')

const link = window.location.href.indexOf('shareidAA=') > -1 ? window.location.href.split('#')[0] + '#' + window.location.href.split('#')[1] : (window.location.href.indexOf('?') > -1 ? window.location.href.split('#')[0] + '#' + window.location.href.split('#')[1] + '&shareid=' + shareid : window.location.href.split('#')[0] + '#' + window.location.href.split('#')[1] + '?shareid=' + shareid)

Vue.wechat.onMenuShareTimeline({
title: 'LIFAair官方商城',

link: link,
imgUrl: 'http://m.lifa-air.cn/weixin/static/images/sharelogo.jpg',

success: function (res) {

}
})

Vue.wechat.onMenuShareAppMessage({
title: 'LIFAair官方商城',
desc: '为每一次呼吸负责',

link: link,
imgUrl: 'http://m.lifa-air.cn/weixin/static/images/sharelogo.jpg',

success: function (res) {

}
})
})
})
.catch(function (error) {

})

const thisshareid = getQueryNew('shareid')
if (thisshareid) {

const postData = {
linkid: thisshareid
}

updateLinkID(postData)
.then(res => {
if (res.data.errorcode === 0) {


} else {

}




})
.catch(err => {

next()


})
}
}
console.log('main-init-19')
next()
}
console.log('main-init-21')
init()
console.log('main-init-22')
})
router.afterEach((to, from, next) => {
console.log('main-init-20')

Vue.$vux.loading.hide()

document.title = to.meta.title
})
/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js